export default "__VITE_ASSET__S8FAB6Nj__"